import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Footer from './footer.js';
import {
    cacheProjects,
    fetchProjects,
    getProjectId,
    readCachedProjects
} from './interactive_data.js';

function getVimeoEmbedUrl(url) {
    if (!url) {
        return null;
    }

    const value = url.trim();

    if (/^\d+$/.test(value)) {
        return `https://player.vimeo.com/video/${value}`;
    }

    try {
        const parsed = new URL(value);

        if (!parsed.hostname.endsWith('vimeo.com')) {
            return null;
        }

        const match = parsed.pathname.match(/\/video\/(\d+)/)
            || parsed.pathname.match(/\/(\d+)(?:\/([a-zA-Z0-9]+))?/);

        if (!match) {
            return null;
        }

        const hash = parsed.searchParams.get('h') || match[2] || '';
        return `https://player.vimeo.com/video/${match[1]}${hash ? `?h=${hash}` : ''}`;
    } catch (error) {
        return null;
    }
}

const Project = () => {
    const { id } = useParams();
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        let active = true;
        window.scrollTo(0, 0);

        async function loadProject() {
            let list = null;

            try {
                list = await fetchProjects();
                cacheProjects(list);
            } catch (error) {
                console.log(error);
                list = readCachedProjects();
            }

            const found = Array.isArray(list)
                ? list.find((item) => getProjectId(item) === id)
                : null;

            if (!active) {
                return;
            }

            setProject(found || null);
            setNotFound(!found);
            setLoading(false);
        }

        loadProject();

        return () => {
            active = false;
        };
    }, [id]);

    if (loading) {
        return (
            <div className="container">
                <div className="load_screen2">CARGANDO...</div>
            </div>
        );
    }

    if (notFound) {
        return (
            <div className="container">
                <div className="project_detail">
                    <Link className="backbtn" to="/interactive">&larr; TODOS LOS PROYECTOS</Link>
                    <h1 className="section_titles project_detail_title">PROYECTO NO ENCONTRADO</h1>
                    <p className="project_detail_desc">No encontramos la información de este proyecto.</p>
                    <Footer/>
                </div>
            </div>
        );
    }

    const videoEmbedUrl = getVimeoEmbedUrl(project.video);

    return (
        <div className="container">
            <div className="project_detail">
                <Link className="backbtn" to="/interactive">&larr; TODOS LOS PROYECTOS</Link>

                <div className="project_detail_header">
                    <div>
                        <p className="project_detail_client">Cliente: {project.client}</p>
                        <h1 className="section_titles project_detail_title">{project.name}</h1>
                    </div>
                    {
                        project.go
                        &&
                        <a className="actionbtn" href={project.go} target="_blank" rel="noreferrer">VER PROYECTO</a>
                    }
                </div>

                {
                    videoEmbedUrl
                    ?
                    <div className="project_detail_video">
                        <iframe
                            src={videoEmbedUrl}
                            title={project.name}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                    :
                    <div className="project_detail_image">
                        <img src={project.link} alt={project.name}/>
                    </div>
                }

                {
                    project.description
                    &&
                    <p className="project_detail_desc">{project.description}</p>
                }

                <Footer/>
            </div>
        </div>
    );
};

export default Project;
